import React from "react";

const getCount = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? Math.max(0, number) : 0;
};

const RequisitionPendingSummaryCard = ({
  data = {},
  onClick
}) => {
  const dashboard = data || {};
  const total = getCount(dashboard.totalSubmitted);

  const summaryItems = [
    {
      key: "project",
      label: "Project Approval",
      value: getCount(dashboard.totalPendingReqProjectManager),
      icon: "fa fa-user",
      subLabel: "Assigned to Project Manager",
      background:
        "linear-gradient(135deg, #1bc596 0%, #0b9d7a 100%)"
    },
    {
      key: "central",
      label: "Central Approval",
      value: getCount(dashboard.totalPendingReqCentralTeam),
      icon: "fa fa-users",
      subLabel: "Assigned to Central Team",
      background:
        "linear-gradient(135deg, #2196f3 0%, #1565c0 100%)"
    },
    {
      key: "ho",
      label: "HO Approval",
      value: getCount(dashboard.totalPendingReqHO),
      icon: "fa fa-shield",
      subLabel: "Assigned to HO",
      background:
        "linear-gradient(135deg, #7e57c2 0%, #5e35b1 100%)"
    },
    {
      key: "priority",
      label: "Priority Requests",
      value: getCount(dashboard.totalPendingReqPriority),
      icon: "fa fa-bolt",
      subLabel: "Priority requisitions",
      background:
        "linear-gradient(135deg, #ff4d6d 0%, #e91e4d 100%)"
    }
  ];

  const cardStyle = {
    height: "100%",
    minHeight: "88px",
    borderRadius: "11px",
    padding: "10px",
    border: "1px solid rgba(255,255,255,0.28)",
    boxShadow: "0 6px 14px rgba(0,0,0,0.16)"
  };

  const labelStyle = {
    fontSize: "11px",
    fontWeight: 600,
    color: "#ffffff"
  };

  const descriptionStyle = {
    fontSize: "9px",
    fontWeight: 500,
    lineHeight: "12px",
    color: "rgba(255,255,255,0.90)",
    minHeight: "12px"
  };

  const actionStyle = {
    display: "block",
    width: "100%",
    padding: 0,
    border: 0,
    background: "transparent",
    color: "#ffffff",
    textAlign: "left",
    cursor: "pointer",
    fontFamily: "inherit"
  };

  const renderIcon = (icon, isTotal = false) => (
    <span
      className="d-flex align-items-center justify-content-center"
      style={{
        width: isTotal ? "42px" : "38px",
        height: isTotal ? "42px" : "38px",
        borderRadius: "50%",
        background: "rgba(255,255,255,0.20)",
        flexShrink: 0
      }}
    >
      <i
        className={icon}
        aria-hidden="true"
        style={{
          fontSize: isTotal ? "18px" : "16px",
          color: "#ffffff"
        }}
      />
    </span>
  );

  return (
    <div
      className="card border-0 mb-3"
      style={{
        borderRadius: "16px",
        overflow: "visible",
        background: "transparent",
        boxShadow: "0 6px 18px rgba(0,0,0,0.08)"
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center flex-wrap gap-2"
        style={{ padding: "10px 14px 3px 14px" }}
      >
        <div>
          <h4
            className="mb-0"
            style={{
              fontSize: "17px",
              fontWeight: 700,
              color: "#212529"
            }}
          >
            Material Requisition Approvals
          </h4>

          <div
            className="mt-1"
            style={{
              color: "#6c757d",
              fontSize: "10px"
            }}
          >
            Overview of all pending requisition approvals
          </div>
        </div>

        <button
          type="button"
          className="btn btn-sm"
          style={{
            color: "#343a40",
            border: "1px solid #ced4da",
            borderRadius: "8px",
            padding: "5px 11px",
            fontSize: "11px",
            fontWeight: 600,
            boxShadow: "0 2px 6px rgba(0,0,0,0.06)"
          }}
          onClick={() => onClick?.("request")}
        >
          View Details
        </button>
      </div>

      <div style={{ padding: "7px 12px 18px" }}>
        <div className="row g-2">
          <div className="col-xl-3 col-lg-4 col-md-12">
            <button
              type="button"
              onClick={() => onClick?.("request")}
              aria-label={`View ${total} pending requisitions`}
              style={{
                ...actionStyle,
                ...cardStyle,
                padding: "11px",
                background:
                  "linear-gradient(135deg, #ff9800 0%, #f57c00 100%)",
                border: "1px solid rgba(255,255,255,0.30)"
              }}
            >
              <span className="d-flex align-items-center gap-2">
                {renderIcon("fa fa-list-alt", true)}

                <span>
                  <span
                    style={{
                      display: "block",
                      fontSize: "25px",
                      fontWeight: 700,
                      lineHeight: 1,
                      color: "#ffffff"
                    }}
                  >
                    {total.toLocaleString()}
                  </span>

                  <span
                    className="mt-1"
                    style={{
                      ...labelStyle,
                      display: "block"
                    }}
                  >
                    Total Pending
                  </span>
                </span>
              </span>
            </button>
          </div>

          <div className="col-xl-9 col-lg-8 col-md-12">
            <div className="row g-2">
              {summaryItems.map((summary) => (
                <div
                  key={summary.key}
                  className="col-xl-3 col-lg-6 col-md-6 col-sm-6"
                >
                  <button
                    type="button"
                    onClick={() => onClick?.("request")}
                    style={{
                      ...actionStyle,
                      ...cardStyle,
                      background: summary.background
                    }}
                  >
                    <span className="d-flex align-items-center gap-2">
                      {renderIcon(summary.icon)}

                      <span>
                        <span
                          style={{
                            display: "block",
                            fontSize: "21px",
                            fontWeight: 700,
                            lineHeight: 1,
                            color: "#ffffff"
                          }}
                        >
                          {summary.value.toLocaleString()}
                        </span>

                        <span
                          className="mt-1"
                          style={{
                            ...labelStyle,
                            display: "block"
                          }}
                        >
                          {summary.label}
                        </span>
                      </span>
                    </span>

                    <span
                      className="mt-2"
                      style={{
                        ...descriptionStyle,
                        display: "block"
                      }}
                    >
                      {summary.subLabel}
                    </span>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequisitionPendingSummaryCard;